import script from "./submitFace.vue?vue&type=script&setup=true&lang=js"
export * from "./submitFace.vue?vue&type=script&setup=true&lang=js"

import "./submitFace.vue?vue&type=style&index=0&id=084f2c5b&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084f2c5b"]])

export default __exports__